import React, { FC } from 'react';
import { ForgeButton, ForgeIcon, ForgeToolbar } from '@tylertech/forge-react';
import { I18n } from 'common/visualizations';

const scope = 'shared.components.schedule_send_report.modal';

interface FooterProps {
  onDelete: () => void;
  onDismiss: () => void;
  onEdit: () => void;
}

const PreviewFooter: FC<FooterProps> = ({ onDelete, onDismiss, onEdit }) => {
  return (
    <ForgeToolbar inverted={true} className="footer-toolbar">
      <div slot="start">
        <ForgeButton
          theme="error"
          variant="text"
          onClick={onDelete}
          aria-label={I18n.t('delete_aria_label', { scope })}
          data-testid="preview-delete-button"
        >
          <ForgeIcon name="trash_can_outline" />
          {I18n.t('delete', { scope })}
        </ForgeButton>
      </div>
      <div slot="end">
        <ForgeButton
          variant="outlined"
          onClick={onDismiss}
          aria-label={I18n.t('close_preview_aria_label', { scope })}
        >
          {I18n.t('close', { scope })}
        </ForgeButton>
        <ForgeButton
          variant="raised"
          onClick={onEdit}
          aria-label={I18n.t('edit_scheduled_report_aria_label', { scope })}
          data-testid="preview-edit-button"
        >
          <ForgeIcon name="edit" aria-hidden="false" external external-type="extended" />
          {I18n.t('edit_schedule', { scope })}
        </ForgeButton>
      </div>
    </ForgeToolbar>
  );
};

export default PreviewFooter;
